import { render, staticRenderFns } from "./RemoteUpgradeDialog.vue?vue&type=template&id=ab23b920&scoped=true&"
import script from "./RemoteUpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./RemoteUpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoteUpgradeDialog.vue?vue&type=style&index=0&id=ab23b920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab23b920",
  null
  
)

export default component.exports